import React from "react";
import * as Scrivito from "scrivito";
import cx from "classnames";
import { useTranslate } from "hooks";
import { useProductsOverviewActions } from "stores/productsOverviewStore";
import { useAllProducts } from "hooks/productHooks/useAllProducts";
import s from "./ProductListLeftSidebar.module.scss";
import { ProductsNavigation } from "./ProductsNavigation";
import { useProjectDataStore } from "stores/projectStore";

export const ProductListLeftSidebar = Scrivito.connect(() => {
  const translate = useTranslate();
  const { navigateToProductListPage } = useProductsOverviewActions();
  const projectId = useProjectDataStore((state) => state.projectId);
  const overviewResetHandler = () => {
    navigateToProductListPage({ projectId });
  };

  const allProducts = useAllProducts();

  return (
    <div
      className={cx(
        s.productsNavigation,
        "ps-4 pe-2 bg-gray-700 h-full-exclude-footer",
      )}
    >
      <h3
        className="py-5 m-0 text-white cursor-pointer text-uppercase"
        onClick={overviewResetHandler}
      >
        {translate("PRODUCT_LIST_LEFTSIDEBAR_NAV_TITLE")}
      </h3>
      <div className={s.productsNavigationList}>
        {allProducts.map((product, key) => (
          <ProductsNavigation key={key} product={product} />
        ))}
      </div>
    </div>
  );
});
